
import { EntitiesStore } from './entities-store.abstract';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
/**
 * Stats of  members
 *
 * @export
 * @interface  IRulebookInterpretations
 */
export interface IRulebookInterpretations {
  approved: string;
  effective: string;
  dismiss: string;
  related: string;
  committee: string;
  title: string;
  content: string;
  articles: ArticlesItem[];
  documents: DocumentsItem[];
}
interface ArticlesItem {
  title: string;
  id: string;
}
interface DocumentsItem {
  title: string;
  link: string;
}



/**
 * Store fore getting the members stats
 *
 * @export
 * @class RulebookInterpretations
 * @extends {EntitiesStore<SeasonMembersStats>}
 */
export class RulebookInterpretationsStore extends EntitiesStore< IRulebookInterpretations> {
  constructor(http: HttpClient, dependencies:Array<any>) {
    super('RB-INTERPRETATION', http, dependencies);
  }
}
